/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Save_PasswordInputs */

const en_password_reset_save_password = /** @type {(inputs: Password_Reset_Save_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save new password`)
};

const es_password_reset_save_password = /** @type {(inputs: Password_Reset_Save_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar contraseña`)
};

/**
* | output |
* | --- |
* | "Save new password" |
*
* @param {Password_Reset_Save_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_save_password = /** @type {((inputs?: Password_Reset_Save_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Save_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_save_password(inputs)
	return en_password_reset_save_password(inputs)
});